// Hauser MX — ficha de propiedad: iconos de la descripción (auto-beautify)
// + barra fija móvil (IntersectionObserver sobre el bloque de precio).
// Progressive enhancement: sin JS, la descripción queda como lista con
// tarjetas sin icono (estilo viene de CSS puro) y la barra fija nunca
// aparece (empieza oculta vía CSS, solo el JS la hace visible).
(function () {
  // Regex exacta pedida por el spec para limpiar emojis del texto del <li>.
  var EMOJI_RE = /[\u{1F000}-\u{1FAFF}\u{2600}-\u{27BF}\u{FE0F}]/gu;

  // Rango de marcas diacríticas combinantes U+0300–U+036F, exactamente el
  // regex pedido por el spec para limpiar acentos tras normalize('NFD').
  var ACCENT_RE = /[̀-ͯ]/g;

  // keyword -> id de símbolo del sprite (hauser-ic-<id>). Los grupos
  // circuito|seguridad|vigilancia y estacionamiento|cochera comparten icono.
  var KEYWORD_MAP = [
    ['cocina', 'cocina'],
    ['isla', 'isla'],
    ['sala', 'sala'],
    ['comedor', 'comedor'],
    ['recamara', 'recamara'],
    ['bano', 'bano'],
    ['tina', 'tina'],
    ['closet', 'closet'],
    ['balcon', 'balcon'],
    ['terraza', 'terraza'],
    ['jardin', 'jardin'],
    ['cantina', 'cantina'],
    ['lavado', 'lavado'],
    ['alberca', 'alberca'],
    ['chapoteadero', 'chapoteadero'],
    ['jacuzzi', 'jacuzzi'],
    ['palapa', 'palapa'],
    ['asador', 'asador'],
    ['hamaca', 'hamaca'],
    ['verdes', 'verdes'],
    ['circuito', 'seguridad'],
    ['seguridad', 'seguridad'],
    ['vigilancia', 'seguridad'],
    ['estacionamiento', 'estacionamiento'],
    ['cochera', 'estacionamiento'],
    ['estudio', 'estudio'],
    ['tv', 'tv'],
    ['elevador', 'elevador'],
    ['bodega', 'bodega'],
    ['cisterna', 'cisterna'],
    ['paneles', 'paneles']
  ];

  function normalizar(texto) {
    return texto.toLowerCase().normalize('NFD').replace(ACCENT_RE, '');
  }

  function iconoParaTexto(textoNormalizado) {
    for (var i = 0; i < KEYWORD_MAP.length; i++) {
      if (textoNormalizado.indexOf(KEYWORD_MAP[i][0]) !== -1) {
        return KEYWORD_MAP[i][1];
      }
    }
    return 'leaf';
  }

  function decorarDescripcion() {
    var items = document.querySelectorAll('.hauser-descripcion ul li');
    if (!items.length) return;

    items.forEach(function (li) {
      var textoOriginal = li.textContent || '';
      var textoLimpio = textoOriginal.replace(EMOJI_RE, '').replace(/\s+/g, ' ').trim();
      li.textContent = textoLimpio;

      var icono = iconoParaTexto(normalizar(textoLimpio));
      li.insertAdjacentHTML(
        'afterbegin',
        '<svg class="hauser-descripcion__icon" aria-hidden="true"><use href="#hauser-ic-' + icono + '"></use></svg>'
      );
    });
  }

  function inicializarBarraSticky() {
    var precio = document.querySelector('[data-hauser-precio-observar]');
    var barra = document.querySelector('[data-hauser-sticky-bar]');
    if (!precio || !barra) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.boundingClientRect.top < 0) {
            barra.classList.add('hauser-sticky-bar--visible');
          } else {
            barra.classList.remove('hauser-sticky-bar--visible');
          }
        });
      },
      { threshold: 0 }
    );

    observer.observe(precio);
  }

  decorarDescripcion();
  inicializarBarraSticky();
})();
